module.exports = __webpack_public_path__ + "media/images/home/about_us/velme_atskirties (copy)-527d3f2abd5aea51ef054beddfb0ff4c.jpg";